const COLLAB_SPACE_ID = 'FluidCollaborativeSpace';

// Determine if the fluid link is a descendant of element with id 'FluidCollaborativeSpace'
// which suggests its part of the html blob for collab space support in down level clients.
export function isDownLevelFluidLink(child: HTMLElement | Node): boolean {
    const parentElement = document.getElementById(COLLAB_SPACE_ID);
    return parentElement?.contains(child);
}
